import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllStateList, getAllCityStateWiseList,
  getAllRelationshipList, getAllOccupationList, getAllLocalityList, getAllEducationalList, getAllJobList, 
  getAllRoomCategoryList, getAllIncomeDetailsList, getAllInjuryTypeList
} from "../../redux/actions/MasterActions";
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { getCurrentDateMysql, getCurrentTimeMysql, getDateTimeMysqlGivenFormatYmd} from '../../util/generalUtills'
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseGenerated = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    pathname,
    actions,
    caseDetailsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [dobDate, setDobDate] = useState(null);
  
  const handleDateChange = (date) => {
    setDobDate(date);
  };

  const genderList = [
    {
      id: "Male",
      name: 'Male'
    },
    {
      id: "Female",
      name: 'Female'
    },
    {
      id: "Other",
      name: 'Other'
    }
  ]

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      masterStateLists,
      masterCityStateWiseLists,
      masterRelationshipList,
      masterOccupationList,
      masterLocalityList,
      masterEducationalList,
      masterJobList,
      masterRoomCategoryList,
      masterIncomeDetailsList,
      masterInjuryTypeList,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (show && auth?.token)
    {
      dispatch(getAllStateList(auth.token));
      dispatch(getAllRelationshipList(auth.token));
      dispatch(getAllOccupationList(auth.token));
      dispatch(getAllLocalityList(auth.token));
      dispatch(getAllEducationalList(auth.token));
      dispatch(getAllJobList(auth.token));
      dispatch(getAllRoomCategoryList(auth.token));
      dispatch(getAllIncomeDetailsList(auth.token));
      dispatch(getAllInjuryTypeList(auth.token));
    }
  }, [show, auth?.token, dispatch]);

  useEffect(() => {
    if (show && auth?.token && stateId) {
      dispatch(getAllCityStateWiseList(auth.token, stateId));
    }
  }, [show, auth?.token, stateId, dispatch]);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(actions.getCaseDetailsListById(auth?.token, editId));
    }
  }, [auth, editId]);
  

  const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
      setValidated(true);
  
      if(id)
      {
        dispatch(actions.saveCaseGeneratedData(auth?.token, formData, id));
      }
      else
      {
        dispatch(actions.saveCaseGeneratedData(auth?.token, formData, id));
      }
    };

  
  useEffect(() => {
    if(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) {
      setFormData({
      });
    }
  }, [caseDetailsLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase();
    setFormData({ ...formData, [name]: processedValue });
  };

  const selectMobileHandler = (e) => {
    const { value, name } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const selectUsernameHandler = (e) => {
    const { value, name } = e.target;
    if (/^[a-z0-9.]{0,30}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
        'official_mail_id': `${value}@asg.com`,
      }));
    }
  };

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };

  const inputDateHandler = (name,value) => {
    setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const customCheckboxMargin = {
    marginBottom: '20px',
    fontSize: '12pt',
    color: 'blue',
  };

  
  useEffect(() => {
    if (changedCaseDetailsStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCaseDetailsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetStatusType });
    }
  }, [changedCaseDetailsStatus, dispatch, onHide, resetStatusType]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update Case Generated") : t("Add Case Generated")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsCaseDetails?.data?.message && (
          <div className="alert alert-danger">
            {errorsCaseDetails?.data?.message}
          </div>
        )}
        <Row>
          <h3 style={{ color: '#d10b0b' }}>Patient Details -: </h3>
          <Col lg={3}>
            <FormInput
              label={t("Patient Name")}
              type="text"
              placeholder={t("Enter Patient Name")}
              errors={errorsCaseDetails?.data}
              value={formData.patient_name}
              name="patient_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
              disabled={formData?.sameAsPrimary}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Patient Phone Number")}
              type="text"
              placeholder={t("Enter Patient Phone Number")}
              errors={errorsCaseDetails?.data}
              value={formData.patient_phone}
              name="patient_phone"
              onChange={selectMobileHandler}
              containerClass={"mb-3"}
              disabled={formData?.sameAsPrimary}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Patient Email")}
              type="text"
              placeholder={t("Enter Patient Email")}
              errors={errorsCaseDetails?.data}
              value={formData.patient_email}
              name="patient_email"
              onChange={inputHandler}
              containerClass={"mb-3"}
              disabled={formData?.sameAsPrimary}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Date Of Birth")}</Form.Label>
              <DatePicker
                selected={formData.patient_dob}
                onChange={(value) => inputDateHandler('patient_dob', value)}
                dateFormat="yyyy-MM-dd"
                maxDate={(() => {
                  const date = new Date();
                  return date;
                })()}
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.patient_dob && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_dob}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Gender")}</Form.Label>
              <Select
                options={genderList}
                values={genderList?.filter(gender => gender?.id === formData?.patient_gender)}
                name="patient_gender"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Patient Gender")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "patient_gender")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.patient_gender && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_gender}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Patient Address")}
              type="text"
              placeholder={t("Enter Patient Address")}
              errors={errorsCaseDetails?.data}
              value={formData.patient_address}
              name="patient_address"
              onChange={inputHandler}
              containerClass={"mb-3"}
              disabled={formData?.sameAsPrimary}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient State")}</Form.Label>
              <Select
                options={masterStateLists}
                values={masterStateLists?.filter(state => state?.state_code === formData?.patient_state)}
                name="patient_state"
                labelField={"state_name"}
                valueField={"state_code"}
                searchBy={"state_name"}
                placeholder={t("Enter Patient State")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.state_code, "patient_state")
                  setStateId(selectedData[0]?.state_code);
                }}
                styles={customSelectStyles}
                disabled={formData?.sameAsPrimary}
              />
              
              {errorsCaseDetails?.data?.patient_state && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_state}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient City")}</Form.Label>
              <Select
                options={masterCityStateWiseLists}
                values={masterCityStateWiseLists?.filter(city => city?.city_code === formData?.patient_city)}
                name="patient_city"
                labelField={"city_name"}
                valueField={"city_code"}
                searchBy={"city_name"}
                placeholder={t("Select Patient City")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.city_code, "patient_city")
                }}
                styles={customSelectStyles}
                disabled={formData?.sameAsPrimary}
              />
              
              {errorsCaseDetails?.data?.patient_city && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_city}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Patient Pincode")}
              type="text"
              placeholder={t("Enter Patient Pincode")}
              errors={errorsCaseDetails?.data}
              value={formData.patient_pincode}
              name="patient_pincode"
              onChange={inputHandler}
              containerClass={"mb-3"}
              disabled={formData?.sameAsPrimary}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient Relationship")}</Form.Label>
              <Select
                options={masterRelationshipList}
                values={masterRelationshipList?.filter(education => education?.id === formData?.patient_relation)}
                name="patient_relation"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Patient Relationship")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "patient_relation")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.patient_relation && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_relation}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient Occupation")}</Form.Label>
              <Select
                options={masterOccupationList}
                values={masterOccupationList?.filter(job => job?.id === formData?.patient_occupation)}
                name="patient_occupation"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Patient Occupation")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "patient_occupation")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.patient_occupation && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.patient_occupation}</p>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Form.Check
              type="checkbox"
              name="is_patient_primary_same"
              containerClass={"mb-3"}
              label={t("Click This If Patient & Insured Member Are Same")}
              checked={formData?.is_patient_primary_same === true}
              onChange={(e) => {
                const isChecked = e.target.checked;
                inputHandler({
                  target: {
                    name: "is_patient_primary_same",
                    value: isChecked,
                  },
                });

                setFormData((prevData) => {
                  const updatedFormData = isChecked
                    ? {
                        ...prevData,
                        is_patient_primary_same: true,
                        primary_name: prevData.patient_name || "",
                        primary_phone: prevData.patient_phone || "",
                        primary_email: prevData.patient_email || "",
                        primary_address: prevData.patient_address || "",
                        primary_state: prevData.patient_state || null,
                        primary_city: prevData.patient_city || null,
                        primary_pincode: prevData.patient_pincode || "",
                        insured_dob: prevData.patient_dob || null,
                        insured_gender: prevData.patient_gender || null,
                      }
                    : {
                        ...prevData,
                        is_patient_primary_same: false,
                        primary_name: "",
                        primary_phone: "",
                        primary_email: "",
                        primary_address: "",
                        primary_state: null,
                        primary_city: null,
                        primary_pincode: "",
                        insured_dob: null,
                        insured_gender: null,
                      };

                  return updatedFormData;
                });
              }}
              style={customCheckboxMargin}
            />
          </Col>
        </Row>

        <Row>
          <h3 style={{ color: '#d10b0b' }}>Primary Insured Details -: </h3>
          <Col lg={3}>
            <FormInput
              label={t("Primary Insured Name")}
              type="text"
              placeholder={t("Enter Primary Insured Name")}
              errors={errorsCaseDetails?.data}
              value={formData.primary_name}
              name="primary_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Primary Insured Phone Number")}
              type="text"
              placeholder={t("Enter Primary Insured Phone Number")}
              errors={errorsCaseDetails?.data}
              value={formData.primary_phone}
              name="primary_phone"
              onChange={selectMobileHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Primary Insured Email")}
              type="text"
              placeholder={t("Enter Primary Insured Email")}
              errors={errorsCaseDetails?.data}
              value={formData.primary_email}
              name="primary_email"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Primary Insured Address")}
              type="text"
              placeholder={t("Enter Primary Insured Address")}
              errors={errorsCaseDetails?.data}
              value={formData.primary_address}
              name="primary_address"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured DOB")}</Form.Label>
              <DatePicker
                selected={formData.insured_dob}
                onChange={(value) => inputDateHandler("insured_dob", value)}
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.insured_dob && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.insured_dob}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured Gender")}</Form.Label>
              <Select
                options={genderList}
                values={genderList?.filter(
                  (gender) => gender?.id === formData?.insured_gender
                )}
                name="insured_gender"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Primary Insured Gender")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "insured_gender");
                }}
                styles={customSelectStyles}
              />
              {errorsCaseDetails?.data?.insured_gender && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.insured_gender}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured State")}</Form.Label>
              <Select
                options={masterStateLists}
                values={masterStateLists?.filter(state => state?.state_code === formData?.primary_state)}
                name="primary_state"
                labelField={"state_name"}
                valueField={"state_code"}
                searchBy={"state_name"}
                placeholder={t("Select Primary Insured State")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.state_code, "primary_state")
                  setStateId(selectedData[0]?.state_code);
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.primary_state && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.primary_state}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured City")}</Form.Label>
              <Select
                options={masterCityStateWiseLists}
                values={masterCityStateWiseLists?.filter(city => city?.city_code === formData?.primary_city)}
                name="primary_city"
                labelField={"city_name"}
                valueField={"city_code"}
                searchBy={"city_name"}
                placeholder={t("Select Primary Insured City")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.city_code, "primary_city")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.primary_city && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.primary_city}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Primary Insured Pincode")}
              type="text"
              placeholder={t("Enter Primary Insured Pincode")}
              errors={errorsCaseDetails?.data}
              value={formData.primary_pincode}
              name="primary_pincode"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Policy Period Start Date")}</Form.Label>
              <DatePicker
                selected={formData.policy_period_from}
                onChange={(value) => inputDateHandler("policy_period_from", value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.policy_period_from && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.policy_period_from}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Policy Period End Date")}</Form.Label>
              <DatePicker
                selected={formData.policy_period_to}
                onChange={(value) => inputDateHandler("policy_period_to", value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showMonthDropdown
                scrollableMonthDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.policy_period_to && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {errorsCaseDetails?.data?.policy_period_to}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Sum Assured")}
              type="text"
              placeholder={t("Enter Sum Assured")}
              errors={errorsCaseDetails?.data}
              value={formData.sum_assured}
              name="sum_assured"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Claim Amount")}
              type="text"
              placeholder={t("Enter Claim Amount")}
              errors={errorsCaseDetails?.data}
              value={formData.claim_amount}
              name="claim_amount"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>
        </Row>

        <Row>
          <h3 style={{ color: '#d10b0b' }}>Others Details -: </h3>
          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Locality")}</Form.Label>
              <Select
                options={masterLocalityList}
                values={masterLocalityList?.filter(locality => locality?.id === formData?.locality_id)}
                name="locality_id"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Locality")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "locality_id")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.locality_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.locality_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Educational Details")}</Form.Label>
              <Select
                options={masterEducationalList}
                values={masterEducationalList?.filter(education => education?.id === formData?.educational_id)}
                name="educational_id"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Educational Details")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "educational_id")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.educational_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.educational_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Job Details")}</Form.Label>
              <Select
                options={masterJobList}
                values={masterJobList?.filter(job => job?.id === formData?.job_details_id)}
                name="job_details_id"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Job Details")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "job_details_id")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.job_details_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.job_details_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Room Category")}</Form.Label>
              <Select
                options={masterRoomCategoryList}
                values={masterRoomCategoryList?.filter(room => room?.id === formData?.room_category)}
                name="room_category"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Room Category")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "room_category")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.room_category && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.room_category}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Income Details")}</Form.Label>
              <Select
                options={masterIncomeDetailsList}
                values={masterIncomeDetailsList?.filter(income => income?.id === formData?.income_details_id)}
                name="income_details_id"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Income Details")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "income_details_id")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.income_details_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.income_details_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Injury Type")}</Form.Label>
              <Select
                options={masterInjuryTypeList}
                values={masterInjuryTypeList?.filter(injury => injury?.id === formData?.injury_type)}
                name="injury_type"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Injury Type")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "injury_type")
                }}
                styles={customSelectStyles}
              />
              
              {errorsCaseDetails?.data?.injury_type && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.injury_type}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Attendent Name")}
              type="text"
              placeholder={t("Enter Attendent Name")}
              errors={errorsCaseDetails?.data}
              value={formData.attendent_name}
              name="attendent_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Attendent Phone Number")}
              type="text"
              placeholder={t("Enter Attendent Phone Number")}
              errors={errorsCaseDetails?.data}
              value={formData.attendent_mobile}
              name="attendent_mobile"
              onChange={selectMobileHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Date Of Injury")}</Form.Label>
              <DatePicker
                selected={formData.date_of_injury}
                onChange={(value) => inputDateHandler('date_of_injury', value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.date_of_injury && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.date_of_injury}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Time Of Injury")}</Form.Label>
              <DatePicker
                selected={formData?.time_of_injury ? new Date(`${getCurrentDateMysql()}T${formData?.time_of_injury}`) : null}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    time_of_injury: getCurrentTimeMysql(value),
                  })
                }
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="HH:mm:ss"
                className="form-control"
                withPortal
                isClearable
              />

              {errorsCaseDetails?.data?.time_of_injury && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.time_of_injury}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Date Of Admission")}</Form.Label>
              <DatePicker
                selected={formData.date_of_admission}
                onChange={(value) => inputDateHandler('date_of_admission', value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.date_of_admission && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.date_of_admission}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Time Of Admission")}</Form.Label>
              <DatePicker
                selected={formData?.time_of_admission ? new Date(`${getCurrentDateMysql()}T${formData?.time_of_admission}`) : null}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    time_of_admission: getCurrentTimeMysql(value),
                  })
                }
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="HH:mm:ss"
                className="form-control"
                withPortal
                isClearable
              />

              {errorsCaseDetails?.data?.time_of_admission && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.time_of_admission}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Date Of Discharge")}</Form.Label>
              <DatePicker
                selected={formData.date_of_discharge}
                onChange={(value) => inputDateHandler('date_of_discharge', value)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                isClearable
              />
              {errorsCaseDetails?.data?.date_of_discharge && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsCaseDetails?.data?.date_of_discharge}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={3}>
            <FormInput
              label={t("Doctor Name")}
              type="text"
              placeholder={t("Enter Doctor Name")}
              errors={errorsCaseDetails?.data}
              value={formData.dr_name}
              name="dr_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-center">
          {loading ? 
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          :
            <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update") : t("Add")}
            </Button>
          }
        </div>
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseGenerated;
